<template>
  <div class="vx-row">
    <div v-if="loading" class="loading-bar">
      <atom-spinner
        :animation-duration="1000"
        :size="60"
        color="#ff1d5e"
        class="mx-auto"
      />
    </div>
    <!-- <vx-card> -->
    <div class="w-full">
      <div
        slot="no-body"
        class="tabs-container inventory_tabSec"
        id="view-customer-tab"
      >
        <vx-card>
          <vs-table
            :max-items="paginationItems[1]"
            pagination
            :data="apnZone"
            :description="false"
            @selected="handleSelected"
            search
            :description-items="paginationItems"
            description-title="Registries"
            description-connector="of"
            description-body="Pages"
          >
            <template slot="header">
              <div class="list-heading">
                {{ $t("setup.label.APNZone") }}
              </div>
              <div class="mr-2 mb-1 order-1">
                <vs-button
                  icon-pack="feather"
                  icon="icon-plus"
                  @click="$router.push({ name: 'Create APN Zone' })"
                  size="small"
                  >{{ $t("setup.label.CreateAPNZone") }}</vs-button
                >
              </div>
            </template>
            <template slot="thead">
              <vs-th>{{ $t("setup.label.APN") }}</vs-th>
              <vs-th>{{ $t("setup.label.ImpactCategory") }}</vs-th>
              <vs-th>{{ $t("setup.label.Rank") }}</vs-th>
              <vs-th class="tHeadCenter">{{ $t("setup.label.Action") }}</vs-th>
            </template>

            <template slot-scope="{ data }">
              <vs-tr
                :key="index"
                :data="apnZone"
                v-for="(apnZone, index) in data"
              >
                <vs-td :data="apnZone.apn">{{ apnZone.apn }}</vs-td>
                <vs-td :data="apnZone.impactCategory">{{
                  apnZone.impactCategory
                }}</vs-td>

                <vs-td :data="apnZone.rank">{{ apnZone.rank }}</vs-td>
                <vs-td class="whitespace-no-wrap">
                  <div class="container_img">
                    <feather-icon
                      icon="EyeIcon"
                      :title="$t('setup.label.View')"
                      svgClasses="w-5 h-5 stroke-current cursor text-primary"
                      @click.stop="handleSelected(apnZone)"
                      class="icon_row"
                    />
                    <feather-icon
                      icon="EditIcon"
                      :title="$t('setup.label.Edit')"
                      svgClasses="w-5 h-5 stroke-current cursor orange_icon"
                      @click.stop="editZoneApn(apnZone.id)"
                      class="icon_row"
                    />
                    <feather-icon
                      icon="TrashIcon"
                      :title="$t('setup.label.Delete')"
                      svgClasses="w-5 h-5 text-danger stroke-current cursor"
                      @click.stop="
                        editJobsUomPopup = true;
                        delId = apnZone.id;
                      "
                      class="icon_row"
                    />
                  </div>
                </vs-td>
              </vs-tr>
            </template>
          </vs-table>
        </vx-card>
      </div>
    </div>
    <delete-popup
      :deletePopup="editJobsUomPopup"
      :title="('setup.label.Apn_Zone')"
      @deletePressed="deleteApnTeam(delId)"
      @cancelPressed="editJobsUomPopup = false"
    >
    </delete-popup>
    <!-- </vx-card> -->
  </div>
</template>
<script>
import { mapState } from "vuex";
import { AtomSpinner } from "epic-spinners";

export default {
  data() {
    return {
      loading: false,
      paginationItems: [5, 10, 15],
      deletePopup: false,
      delId: 0,
      deleatId: 0,
      editJobsUomPopup: false,
      editJobsRumPopup: false,
      deleteIcPopup: false,
      deleteNumberZonePopup: false,
      // provisioningRumList: [],
      // hardwareUomList: [],
      provisioningActionsList: [],
      networkElementList: [],
    };
  },
  components: { AtomSpinner },
  computed: {
    ...mapState({
      apnZone: (state) => state.zoneSetup.GetApnZone,
      operatorZone: (state) => state.zoneSetup.GetOperatorZone,
      icZone: (state) => state.zoneSetup.GetIcZone,
      numberZone: (state) => state.zoneSetup.GetNumberZone,
      products: (state) => state.zoneSetup.GetUsageRatePlan,
    }),
  },
  methods: {
    async getApnZoneData() {
      this.loading = true;
      try {
        this.$store.dispatch("zoneSetup/setApnZoneList", {});
      } catch (error) {
        throw Error(
          error.message.errors[0].defaultUserMessage ||
            `Api failed with status code: ${error.message.httpStatusCode}`
        );
      }
      this.loading = false;
    },
    async deleteApnTeam(id) {
      try {
        this.editJobsUomPopup = false;
        try {
          await this.$store.dispatch("zoneSetup/deleteApnZone", id);
          this.getApnZoneData();
          this.$swal({
            title: "Success",
            icon: "success",
            text: "APN Zone Deleted Successfully!",
            type: "success",
          });
        } catch (error) {
          this.$toasted.error("Something Went Wrong", {
            duration: 2000,
          });
        }
      } catch (error) {
        throw Error(
          error.message.errors[0].defaultUserMessage ||
            `Api failed with status code: ${error.message.httpStatusCode}`
        );
      }
    },

    editZoneApn(id) {
      this.$router.push({ name: "Edit APN Zone", params: { id: id } });
    },
    handleSelected(apnZone) {
      this.$router.push({
        name: "View APN Zone",
        params: { id: apnZone.id },
      });
    },
  },
  mounted() {
    this.getApnZoneData();
  },
};
</script>
<style scoped>
::v-deep .vs-tabs--ul {
  width: 90%;
}
.inventory_tabSec >>> .con-vs-tabs .vs-tabs--ul {
  box-shadow: none !important;
}
</style>
